import React from 'react';
import buttonImage from '../buttonimage.webp'; // Import button image
import backgroundImage from '../background.webp'; // Import background image
import cardBackgroundImage from '../cardbackground.webp'; // Import card background image
import { supabase } from '../supabaseClient';

function Abundance({ goBack, goHome }) {
    const handleSaveProgress = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                alert('User not logged in!');
                return;
            }
            const { error: progressError } = await supabase
                .from('user_progress')
                .upsert({
                    user_id: user.id,
                    current_question_id: null,
                    current_component: 'abundance',
                    animated_helper: 'no', // always set to 'no'
                    timestamp: new Date().toISOString(),
                });
            if (progressError) {
                alert('Failed to save progress: ' + progressError.message);
                return;
            }
            alert('Session progress has been saved successfully!');
        } catch (err) {
            alert('An unexpected error occurred while saving progress.');
        }
    };

    return (
        <>
            <style>
                {`
                @media (max-width: 600px) {
                    .abundance-btn-row {
                        flex-direction: row !important;
                        gap: 6px !important;
                    }
                    .abundance-btn {
                        width: 32vw !important;
                        min-width: 0 !important;
                        max-width: 100px !important;
                        padding: 10px 0 !important;
                        font-size: 16px !important;
                    }
                }
                `}
            </style>
            <div style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '16px',
            }}>
                {/* Title */}
                <h3 style={{
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: 'black',
                    marginBottom: '32px',
                }}>
                    Abundance
                </h3>

                {/* Top Card with Image, Title, and Subtitle */}
                <div
                    style={{
                        width: '100%',
                        maxWidth: '600px',
                        borderRadius: '10px',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        border: '2px solid black',
                        marginBottom: '24px',
                        overflow: 'hidden',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        textAlign: 'center',
                    }}
                >
                    <img
                        src={require('../mirrorimage.webp')}
                        alt="Mirror"
                        style={{
                            width: '100%',
                            borderRadius: '10px 10px 0 0',
                            objectFit: 'cover',
                            maxHeight: '220px',
                        }}
                    />
                    <div
                        style={{
                            padding: '24px',
                            background: 'rgba(255,255,255,0.85)',
                            borderBottomLeftRadius: '10px',
                            borderBottomRightRadius: '10px',
                        }}
                    >
                        <h2
                            style={{
                                fontFamily: 'Times New Roman, Times, serif',
                                fontSize: '28px',
                                fontWeight: 'bold',
                                color: '#4B5563',
                                margin: '0 0 16px 0',
                            }}
                        >
                            Abundance
                        </h2>
                        <p
                            style={{
                                fontFamily: 'Times New Roman, Times, serif',
                                fontSize: '16px',
                                color: '#4B5563',
                                margin: 0,
                            }}
                        >
                            Having what you need when you need it
                        </p>
                    </div>
                </div>

                {/* Session Helper Cards Row */}
                <div
                    className="abundance-session-helper-row"
                    style={{
                        display: 'flex',
                        flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                        gap: '16px',
                        width: '100%',
                        maxWidth: '600px',
                        marginBottom: '16px',
                    }}
                >
                    {/* Left Card */}
                    <div style={{
                        flex: 1,
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'left',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        marginBottom: window.innerWidth <= 600 ? '16px' : 0,
                    }}>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                            •  Abundance is having what you need when you need it<br />
                            • Abundance allows us to give from our overflow<br />
                            • Abundance is not experienced when we have a lack mindset<br />
                            • The momentum of lack can keep us from abundance<br />
                            •  Abundance thrives when we cultivate gratitude, as it shifts focus from scarcity to the wealth of opportunities and resources already present in our lives.<br />
                            • An abundant mindset fosters connection and collaboration, enabling us to share resources and create mutual prosperity without fear of depletion.
                        </div>
                    </div>
                    {/* Right Card */}
                    <div style={{
                        flex: 1,
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'left',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                            1. Do you expect to always have what you need when you need it?<br />
                            2. What do you think of other people who have abundance?<br />
                            3. What small daily practice could you adopt to notice and appreciate the abundance already present in your life?<br />
                            4. How does your current relationship with money or resources reflect a belief in abundance or scarcity?<br />
                            5. What is one fear that stops you from fully trusting that abundance is available to you, and how might you challenge it?<br />
                            6. How would your actions or decisions change if you believed abundance was your natural state?
                        </div>
                    </div>
                </div>

                {/* Cards */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '16px',
                    width: '100%',
                    maxWidth: '600px',
                }}>
                    {/* Card 1 */}
                    <div style={{
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'center',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <p style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: 'black',
                        }}>
                            Abundance is having more than what you need.  You can be abundant in many different ways.  If look for the places in your life where you have more than you need.  These are the places you find your wealth.  This topic is so important becasuse one defining factor of what limits us as people is the concept of lack.  Sometimes an atmosphere of lack has been cultivated in our lives, passed down from generations before us.  I am not enough, or there is not enough mindsets are two ways that lack can live in our lives. One reason why the topic of abundance is important is because it disillusions us on what is really going on.  If we have been practicing the idea of lack in our lives then we will naturally limit ourselves and be more likely to fall into the traps of the "7 deadly sins".  Humans have access to the lower natures through decisions we make.  We are more likely to be open to entertaining the traps of the lower natures when we believe in lack.  If there is not enough I am more likely to be greedy, or experience wrath when someone takes something I feel that I need. If I am not enough I am more likely to be Sloth, prideful, or indulge in lust to distract myself from the pain of it. The thing is, yes these lower nature states exist and we can even derive some joy from them at times.  The reason they are troublesome is that we can also get stuck repeatimg them over and over which acts like a trap by keeping us from having new experiences, creating change and growing past our limitations. Having an Abundant mindset just means that we notice the places that we do have enough and more.  We focus on gratitude for what we have to share.  We understand that there is a solution when we open ourselves to it.  If instead we focus on not having enough, we end up skipping gratitude and slumping into an uncomfortable loop where we line up with more experienes that we also perceive lack in. If we are practiced in noticing lack then we may need to practice noticing abundance.  Sometimes abundance is having an extra roll of toilet paper or a few grapes to share. Sometimes abundance is having the perfect advice when asked, or the smile a stranger needed to receive.
                        </p>
                    </div>

                    {/* Card 2 */}
                    <div style={{
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'center',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <p style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: 'black',
                        }}>
                            There is a great joy in giving.  Being in service to those around us is a great honor.  We cut ourselves off from that when we do not practice noticing our abundance and allowing ourselves to feel abundant.  It is ok if we cannot feel abundant, or if we feel like something is missing from our lives.  It is simply an indication that there is something in the way of your abundance mindset.  We are all in progress, so starting from where we are at is all we need to do.  It is important to be in the place we are at.  If we stop resisting it,and start observing it, there will be something there for us to learn, to know, to experience.  Something meaningful that can impact us.  Accepting where we are at on the topic of abundance is an important step in the process of allowing an abundant mindset. We have a life full of experiences and an upbringing that helped shape our views on this topic.  Sometimes it is not as easy as deciding to change our mind.  Sometimes we need to go deeper into our beliefs and reasons for believing in lack before we can allow abundance.  The truth is, both exist and we as humans have the ability to choose to untangle ourselves from how we have been living on the topic and then decide how we want to live in the topic.   
                        </p>
                    </div>

                    {/* Card 3 */}
                    <div style={{
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'center',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <p style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: 'black',
                        }}>
                            Reflect on the abundance in your life and how it shapes your mindset. Are you more inclined to notice the lack in your life? Did you grow up in an environment that was abundant in your perspective? How did your upbringing shape your views of abundance and lack, and how is that effecting you today?
Are you satisifed with your mindset on abundance or do you think you would like to work on cultivating an abundance mindset? How can abundance mindset lead to you to fulfillment? Explore how sharing abundance can create positive ripple effects. Do you experience joy when you are able to share with others? In what areas of life are you abundant?
                        </p>
                    </div>
                    {/* New Card with Image */}
                    <div style={{
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'center',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <img
                            src="/images/results%20meme.webp"
                            alt="Why we don't get the results we want:  Sometimes it's not what we are doing or not doing, but the intention we hold, the reasons we have, the justification we tell, or what we are trying to avoid by doing or not doing it. "
                            style={{
                                width: '100%',
                                height: 'auto',
                                maxHeight: '220px',
                                objectFit: 'contain',
                                borderRadius: '8px',
                                marginBottom: '12px'
                            }}
                        />
                    </div>
                </div>

                {/* Navigation Buttons */}
                <div
                    className="abundance-btn-row"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '16px',
                        marginTop: '32px',
                    }}>
                    <button
                        className="abundance-btn"
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            width: '120px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        }}
                        onClick={goBack}
                    >Back</button>
                    <button
                        className="abundance-btn"
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            width: '120px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        }}
                        onClick={goHome}
                    >Home</button>
                    <button
                        className="abundance-btn"
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            width: '120px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        }}
                        onClick={handleSaveProgress}
                    >Save</button>
                </div>
            </div>
        </>
    );
}

export default Abundance;
